import React from 'react';

const SvgCurvedArrow = (props) => (
  <svg width={16} height={14} {...props}>
    <path
      fill="#868E96"
      fillRule="evenodd"
      d="M7.307 4.643V.332a.332.332 0 0 0-.568-.235L.097 6.726a.33.33 0 0 0 0 .468l6.642 6.63a.332.332 0 0 0 .568-.234V9.293c1.438.071 7.051.554 7.983 3.727a.332.332 0 1 0 .651-.094c0-7.604-7.079-8.236-8.634-8.283z"
    />
  </svg>
);

export default SvgCurvedArrow;
